import React, {PureComponent} from 'react';
import styled from 'styled-components';

class Form extends PureComponent {
  handleSubmit = e => {
    const {onSubmit} = this.props;
    e.preventDefault();

    if (onSubmit) {
      onSubmit(e);
    }
  }

  render() {
    return <form {...this.props} onSubmit={this.handleSubmit} />;
  }
}

const FormGroup = styled.div`
  margin-top: 1.5rem;

  :first-child {
    margin-top: 0;
  }
`;

Form.Group = FormGroup;
export default Form;